import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { KundeDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/kunde-dto';
import { BetalerDialogData } from '../../aftale/models';

@Component({
    selector: 'app-betaler-dialog',
    templateUrl: './betaler-dialog.component.html',
    styleUrls: ['./betaler-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BetalerDialogComponent implements OnInit {
  kunde: KundeDto;
  constructor(@Inject(MAT_DIALOG_DATA) public data: BetalerDialogData) {
    this.kunde = data.kunde;
  }

  ngOnInit(): void {}
}
